module.exports = __webpack_public_path__ + "img/camera.15fa4e90.svg";